/* tslint:disable */
/* eslint-disable */
/**
 * Portfolio-tracker
 * Portfolio-tracker
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface AdsConsentStateDto
 */
export interface AdsConsentStateDto {
    /**
     * 
     * @type {number}
     * @memberof AdsConsentStateDto
     */
    generation: number;
    /**
     * 
     * @type {boolean}
     * @memberof AdsConsentStateDto
     */
    advertisingConsent: boolean;
}

export function AdsConsentStateDtoFromJSON(json: any): AdsConsentStateDto {
    return AdsConsentStateDtoFromJSONTyped(json, false);
}

export function AdsConsentStateDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): AdsConsentStateDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'generation': json['generation'],
        'advertisingConsent': json['advertisingConsent'],
    };
}

export function AdsConsentStateDtoToJSON(value?: AdsConsentStateDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'generation': value.generation,
        'advertisingConsent': value.advertisingConsent,
    };
}

